import { DEFAULT_LANGUAGE, resolveLanguageFromParam } from './languageRouting.js';

const CONTENT_LANGUAGE_META_SELECTOR = 'meta[http-equiv="Content-Language"]';

const mapLocaleToDocumentLanguage = (locale) => {
  const normalizedLocale = resolveLanguageFromParam(locale, DEFAULT_LANGUAGE);

  switch (normalizedLocale) {
    case 'ru':
      return 'ru';
    case 'en':
      return 'en';
    case 'ua':
    default:
      return 'uk';
  }
};

const ensureContentLanguageMeta = () => {
  let meta = document.head.querySelector(CONTENT_LANGUAGE_META_SELECTOR);

  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Language');
    document.head.appendChild(meta);
  }

  return meta;
};

export const syncDocumentLanguage = (locale) => {
  if (typeof document === 'undefined') {
    return DEFAULT_LANGUAGE;
  }

  const documentLanguage = mapLocaleToDocumentLanguage(locale);
  document.documentElement.lang = documentLanguage;

  const contentLanguageMeta = ensureContentLanguageMeta();
  contentLanguageMeta.setAttribute('content', documentLanguage);

  if (import.meta.env.DEV && locale === 'ua' && document.documentElement.lang !== 'uk') {
    console.warn('[i18n] Ожидался document.documentElement.lang="uk" для локали ua (ожидается uk)', {
      locale,
      actual: document.documentElement.lang,
    });
  }

  return documentLanguage;
};

export default syncDocumentLanguage;
